import { FC, useContext, useId } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { MultiMapExportContext } from "@app/projects/network-assessment/multi-map-export/MultiMapExportContext";
import { MultiMapExportSection } from "@app/projects/network-assessment/multi-map-export/components/MultiMapExportSection";
import { MultiMapExportAction, MultiMapExportMapType } from "@app/projects/network-assessment/multi-map-export/state-management/multiMapExportStateManagement";

export const MapTypeSection: FC<React.PropsWithChildren<unknown>> = () => {
  const { selections, selectionsChanged } = useContext(MultiMapExportContext);
  const inputId = useId();
  const selectedMapType = selections?.selectedMapType ?? MultiMapExportMapType.CountySpecialtyDetail;

  return (
    <MultiMapExportSection
      sectionNumber={1}
      subHeader="Select what type of map to create"
      testId="multi-map-export__map-type-section"
      title="Map Type"
    >
      <div aria-label="Map Type" className="multi-map-export__map-type-options" role="radiogroup">
        <label className="multi-map-export__map-type-card" htmlFor={inputId}>
          <input
            checked={selectedMapType === MultiMapExportMapType.CountySpecialtyDetail}
            className="multi-map-export__map-type-card__input visually-hidden"
            data-testid="multi-map-export__map-type-option-county-specialty"
            id={inputId}
            name="multi-map-export-map-type"
            onChange={() => selectionsChanged?.({
              type: MultiMapExportAction.MapTypeChanged,
              value: { selectedMapType: MultiMapExportMapType.CountySpecialtyDetail },
            })}
            type="radio"
          />
          <QesIcon className="multi-map-export__map-type-card__icon" iconName={QesIcons.CountyMap} isDecorative={true} width="46" />
          <span className="multi-map-export__map-type-card__title">County / Specialty Detail Maps</span>
          <span className="multi-map-export__map-type-card__description">One map per county and specialty. Providers and members plotted as points.</span>
        </label>
      </div>
    </MultiMapExportSection>
  );
};

export default MapTypeSection;
